import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useEncumbranceDetailsPage } from '../context/EncumbranceDetailsPageContext';
import CoOwnersHeader from './CoOwnersHeader';
import CoOwnersTable from './CoOwnersTable';

const CoOwnersSection: FC = () => {
  const { data, actions } = useEncumbranceDetailsPage();

  const showPagination = data.coOwners && data.coOwnersTotal > 10;

  return (
    <div>
      <CoOwnersHeader />
      <CoOwnersTable />

      {showPagination && (
        <TablePagination
          totalRows={data.coOwnersTotal}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default CoOwnersSection;
